import * as Contract from '../../ExtensionsApiExternalContract';

import { CallbackMap, ExtensionsImpl } from '../Impl/ExtensionsImpl';

/**
 * Implementation of the external Extensions namespace.
 */
export class Extensions implements Contract.Extensions {
  public constructor(private extensionImpl: ExtensionsImpl) {
    this.extensionImpl = extensionImpl;
  }

  public get dashboardContent(): Contract.DashboardContent {
    return this.extensionImpl.dashboardContent;
  }

  public get environment(): Contract.Environment {
    return this.extensionImpl.environment;
  }

  public get settings(): Contract.Settings {
    return this.extensionImpl.settings;
  }

  public get ui(): Contract.UI {
    return this.extensionImpl.ui;
  }

  public initializeAsync(contextMenuCallbacks?: CallbackMap): Promise<void> {
    return this.extensionImpl.initializeAsync(false, contextMenuCallbacks).then<void>();
  }

  public initializeDialogAsync(): Promise<string> {
    return this.extensionImpl.initializeAsync(true);
  }
}



// WEBPACK FOOTER //
// ../../../../src/ExtensionsApi/Namespaces/Extensions.ts


// WEBPACK FOOTER //
// webpack:///src/ExtensionsApi/Namespaces/Extensions.ts